import React, { useState ,useEffect} from 'react';
import {
  TbTruckDelivery,
  TbCategory2,
  TbReceipt,
  TbLayout,
  TbSettings,
  TbShieldCheck,
  TbCreditCard,
  TbReportAnalytics,
  TbAdjustments,
  TbArrowsExchange,
  TbCalendarEvent,
} from 'react-icons/tb';
import { FiCodesandbox } from 'react-icons/fi';
import { AiOutlineLineChart } from 'react-icons/ai';
import { MdOutlineInventory2, MdQueryStats } from 'react-icons/md';
import { LuCombine, LuHistory, LuCodesandbox, LuWallet } from 'react-icons/lu';
import { PiAddressBookBold } from 'react-icons/pi';
import { MdOutlineDeliveryDining } from 'react-icons/md';
import { IoStatsChart, IoPeople } from 'react-icons/io5';
import { MdKeyboardArrowDown, MdKeyboardArrowUp, MdCalendarViewWeek } from 'react-icons/md';
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import { connect } from 'react-redux';
import { setMobSideNavBarVisibility } from '../../../../common/actions/index';
import Axios from '../../../../common/util/Axios';
import { fetchIsModifierCompany } from '../../../reports/billHistory/utils/companyType';


const SideNavBar = ({
  setMobSideNavBarVisibility,
  common: { showMobSideNavBar },
  auth: { companyId, branchId },
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openedSubMenuId, setOpenedSubMenuId] = useState(null);
  const [isHirePurchaseEnabled, setIsHirePurchaseEnabled] = useState(false);
  const [modifiersEnabled, setModifiersEnabled] = useState(false);

  const menuItems = [
    {
      id: 1,
      name: 'Dashboard',
      icon: <AiOutlineLineChart />,
      route: '/',
    },
    {
      id: 2,
      name: 'Inventory',
      icon: <MdOutlineInventory2 />,
      route: '/inventory',
      children: [
        { id: 1, name: 'Products', icon: <FiCodesandbox />, route: '/inventory/products' },
        { id: 2, name: 'Stocks', icon: <LuCombine />, route: '/inventory/stocks' },
        { id: 3, name: 'Transferred Stocks', icon: <TbArrowsExchange />, route: '/inventory/transfer-stocks' },
        // { id: 3, name: 'Invoices', icon: <TbFileInvoice />, route: '/inventory/invoices' },
        { id: 4, name: 'Stats', icon: <MdQueryStats />, route: '/inventory/stats' },
        { id: 5, name: 'Categories', icon: <TbCategory2 />, route: '/inventory/categories' },
        { id: 6, name: 'Suppliers', icon: <TbTruckDelivery />, route: '/inventory/suppliers' },
        ...(modifiersEnabled
          ? [{ id: 7, name: 'Modifiers', icon: <TbAdjustments />, route: '/inventory/modifiers' }]
          : []),
      ],
    },
    {
      id: 3,
      name: 'CRM',
      icon: <PiAddressBookBold />,
      route: '/crm',
      children: [
        { id: 1, name: 'Customers', icon: <IoPeople />, route: '/crm/customers' },
      ],
    },
    {
      id: 4,
      name: 'Delivery',
      icon: <MdOutlineDeliveryDining />,
      route: '/delivery',
      children: [
        { id: 1, name: 'Shipments', icon: <TbTruckDelivery />, route: '/delivery/shipments' },
      ],
    },
    {
      id: 5,
      name: 'Reports',
      icon: <IoStatsChart />,
      route: '/reports',
      children: [
        { id: 1, name: 'Sales', icon: <TbReportAnalytics />, route: '/reports/sales' },
        { id: 6, name: 'Cash Balance', icon: <LuWallet />, route: '/reports/cash-balance' },
        { id: 2, name: 'Product summary', icon: <LuCodesandbox />, route: '/reports/products' },
        { id: 3, name: 'Category', icon: <TbCategory2 />, route: '/reports/category' },
        { id: 4, name: 'Customers', icon: <IoPeople />, route: '/reports/customers' },
        { id: 5, name: 'Bill History', icon: <LuHistory />, route: '/reports/bill-history' }
      ],
    },
    {
      id: 6,
      name: 'IAM',
      icon: <TbShieldCheck />,
      route: '/iam',
      children: [
        { id: 1, name: 'Users', icon: <IoPeople />, route: '/iam/users' }
      ],
    },
    {
      id: 7,
      name: 'Settings',
      icon: <TbSettings />,
      route: '/settings',
      children: [
        { id: 1, name: 'General', icon: <TbAdjustments />, route: '/settings/general' },
        { id: 2, name: 'Receipt', icon: <TbReceipt />, route: '/settings/receipt' },
        { id: 3, name: 'Warranty', icon: <TbShieldCheck />, route: '/settings/warranty' },
        { id: 4, name: 'Products', icon: <FiCodesandbox />, route: '/settings/products' },
        { id: 5, name: 'Layout', icon: <TbLayout />, route: '/settings/layout' },
        { id: 6, name: 'Payment', icon: <TbCreditCard />, route: '/settings/payments' },
        { id: 7, name: 'Order', icon: <TbLayout />, route: '/settings/order' },
        { id: 8, name: 'Business Day', icon: <TbCalendarEvent />, route: '/settings/business-day' },
        ...(modifiersEnabled
          ? [{ id: 9, name: 'Modifiers', icon: <TbAdjustments />, route: '/settings/modifiers' }]
          : []),
      ],
    },
    {
      id: 9,
      name: "Account",
      icon: <TbSettings />,
      route: "/account",
      children: [
        {
          id: 1,
          name: "Subscription",
          icon: <MdCalendarViewWeek />,
          route: "/account/subscription",
        },
      ],
    },
  ];

  if (isHirePurchaseEnabled) {
    menuItems.splice(3, 0, {
      id: 8,
      name: 'Hire Purchase',
      icon: <TbCreditCard />,
      route: '/hire-purchase',
      children: [
        {
          id: 1,
          name: 'Agreements',
          icon: <TbCreditCard />,
          route: '/hire-purchase/agreements',
        },
      ],
    });
  }

  useEffect(() => {
    if (location.pathname.startsWith('/hire-purchase')) {
      setOpenedSubMenuId(8);
    } else if (location.pathname.startsWith('/reports')) {
      setOpenedSubMenuId(5);
    }
  }, [location.pathname]);

  useEffect(() => {
    const loadHirePurchaseFlag = async () => {
      if (!companyId || !branchId) {
        setIsHirePurchaseEnabled(false);
        return;
      }

      try {
        const res = await Axios.get('/api/dashboard/settings/find-product-settings-for-branch', {
          params: { companyId, branchId },
        });
        const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
        const scopedItems = rows.filter(
          (item) =>
            item?.param === 'is-hire-purchase-enabled' &&
            String(item?.value ?? '').toLowerCase() === 'true'
        );
        setIsHirePurchaseEnabled(scopedItems.length > 0);
      } catch (error) {
        setIsHirePurchaseEnabled(false);
      }
    };

    loadHirePurchaseFlag();
  }, [companyId, branchId]);

  useEffect(() => {
    const loadModifiers = async () => {
      const enabled = await fetchIsModifierCompany(companyId);
      setModifiersEnabled(enabled);
    };
    loadModifiers();
  }, [companyId]);

  const clickOnMenuItem = (route) => {
    setMobSideNavBarVisibility(showMobSideNavBar);
    navigate(route);
  };

  const clickOnMenuItemWithChildren = (menuItem) => {
    if (openedSubMenuId === menuItem.id) {
      setOpenedSubMenuId(null);
    } else {
      setOpenedSubMenuId(menuItem.id);
    }
  };

  return (
    <div className={styles.sideNavBar}>
      {menuItems.map((menuItem) => (
        <div key={menuItem.id} className={styles.menuItemContainer}>
          <div
            className={
              location.pathname === menuItem.route && !menuItem.children
                ? styles.menuItemActive
                : styles.menuItem
            }
            onClick={() =>
              menuItem.children
                ? clickOnMenuItemWithChildren(menuItem)
                : clickOnMenuItem(menuItem.route)
            }
          >
            <div className={styles.innerMenuItemDiv}>
              <span className={styles.menuIcon}>{menuItem.icon}</span>
              <h3>{menuItem.name}</h3>
            </div>
            {menuItem.children && (
              openedSubMenuId === menuItem.id ? (
                <MdKeyboardArrowUp className={styles.arrow} />
              ) : (
                <MdKeyboardArrowDown className={styles.arrow} />
              )
            )}
          </div>

          {menuItem.children && openedSubMenuId === menuItem.id && (
            menuItem.children.map((subItem) => (
              <div key={subItem.id} className={styles.subMenuDiv}>
                <div
                  className={
                    location.pathname === subItem.route 
                      ? styles.subMenuItemActive
                      : styles.subMenuItem
                  }
                  onClick={() => clickOnMenuItem(subItem.route)}
                >
                  <div className={styles.innerMenuItemDiv}>
                    <span className={styles.menuIcon}>{subItem.icon}</span>
                    <h3>{subItem.name}</h3>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      ))}
      <div className={styles.mobSpacer} />
    </div>
  );
};

SideNavBar.propTypes = {
  setMobSideNavBarVisibility: PropTypes.func.isRequired,
  auth: PropTypes.shape({
    companyId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    branchId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }).isRequired,
};

const mapStateToProps = (state) => ({
  common: state.commonState,
  auth: state.authState,
});

export default connect(mapStateToProps, {
  setMobSideNavBarVisibility,
})(SideNavBar);
